import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { ShellComponent } from './shell.component';
import { ContactscreenModule } from '../@root-redux/contactscreen/contactscreen.module';
import { ComponentsModule } from '../shared/components/components.module';
import { ReactiveFormsModule } from '@angular/forms';
import { EquisLoadingModule } from '@tn-equis/core/components/loading';

@NgModule({
  imports: [
    ReactiveFormsModule,
    CommonModule,
    TranslateModule,
    RouterModule,
    ComponentsModule,
    ContactscreenModule,
    EquisLoadingModule,
  ],
  providers: [],
  declarations: [ShellComponent],
})
export class ShellModule {}
